import * as React from 'react';
import Accordion from 'src/app/Container/Accordion/Accordion';

import {
  AngleOfNiche, 
  TypeOfInstallation, 
  CornerDesign,
  PlateDimensions,
  Distances,
  ElementNext,
} from 'src/app/Partials/Configuration/Inputs';

import { connect } from 'react-redux';
import { ConfigurationModel, WashBasinDefaultModel } from 'franke-trough-dependencies';

import { 
  GlobalPrivateState, 
  formatMessage,
  NavigationConfigurationKeys,
  WashBasinDimensionKeys,
} from 'src/api';

import { requestAPIActions } from 'loopback-react-request';
import { ConfigurationHeader } from 'src/app/Partials';
import ConfigurationPart, { ConfigurationPartProps } from 'src/app/Partials/Configuration/Utils/ConfigurationPart';

import MESSAGES from '../ConfigurationDetail.messages';

import 'rc-slider/assets/index.css';
import './ConfiguraionBasinDimensions.page.scss';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ConfigurationBasinDimensionsPageProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  validated: GlobalPrivateState['validatedConfiguration'];
}

export class ConfigurationBasinDimensionsPageComponent extends React.Component<ConfigurationBasinDimensionsPageProps, any> {
  componentDidMount() {
    this.dispatchDefaults();
  }

  public render() {
    return (
      <div className="page-configuration-basin-dimensions">
        <div className="col-12">
          <ConfigurationHeader
            icon="washbasin-dimensions"
            title={formatMessage(MESSAGES.washbasinDimensions)}
          />
        </div>
        <div className="configuration-wrap pl-5 pr-5 pt-1">
          <div className="col-12 pb-3 pl-0 pr-0">
            <Accordion>
              {this.basinDimensionParts.map((props, index) => {
                const key = `configuration_basin_dimensions_${index}`;
                return (
                  <ConfigurationPart
                    key={key}
                    {...props}
                  />
                );
              })}
            </Accordion>
          </div>
          <div className="col-12 pb-3 pt-3 text-center">
            <ElementNext id={NavigationConfigurationKeys.washBasinDimension} />
          </div>
        </div>
      </div>
    );
  }

  private get defaults(): WashBasinDefaultModel | undefined {
    const { configuration } = this.props;
    const confDefaults = configuration.result && configuration.result && configuration.result.defaults;
    return confDefaults && confDefaults.washBasinDimension;
  }

  private dispatchDefaults() {
    const { configuration } = this.props;
    
    if (!isConfigurationEditable()) { return; }

    if (configuration && configuration.result && !configuration.result.washBasinDimension) {
      const defaults = this.defaults;
      if (defaults) {
        const data: ConfigurationModel['washBasinDimension'] = {
          typeOfInstallation: defaults.typeOfInstallation.default,
          angleOfNiche: defaults.angleOfNiche.default,
          cornerDesign: defaults.cornerDesign.default,
          cornerDesignPosition: defaults.cornerDesignPosition.default,
          plateWidth: defaults.plateWidth.default,
          plateDepth: defaults.plateDepth.default,
        };
        this.props.dispatch(requestAPIActions.load(
          'configuration',
          {
            url: `/Configurations/${configuration.result.id}`,
            options: {
              method: 'PATCH',
              data: {
                washBasinDimension: data,
                apronBackSplash: {
                  restorablePlateDimensions: null
                }
              },
            },
          },
          true
        ));
      }
    }
  }

  private get basinDimensionParts(): ConfigurationPartProps[] {
    const validated = this.props.validated.byItem.washBasinDimension;    
    return [{
      btnName: formatMessage(MESSAGES.typeOfInstallation),
      component: TypeOfInstallation,
      error: [validated && validated.typeOfInstallation || false] || undefined,
      id: WashBasinDimensionKeys.TypeOfInstallation,
    }, {
      btnName: formatMessage(MESSAGES.cornerDesign),
      component: CornerDesign,
      error: [
        validated && validated.cornerDesign || false,
        validated && validated.cornerDesignPosition || false
      ] || undefined,
      id: WashBasinDimensionKeys.CornerDesign,
    }, {
      btnName: formatMessage(MESSAGES.plateDimensions),
      component: PlateDimensions,
      error: [
        validated && validated.plateWidth || false, 
        validated && validated.plateDepth || false
      ] || undefined ,
      id: WashBasinDimensionKeys.PlateDimensions,
    }, {
      btnName: formatMessage(MESSAGES.distancesInMM),
      component: Distances,
      error: [validated && validated.distances || false] || undefined,
      id: WashBasinDimensionKeys.Distances,
    }, {
      btnName: formatMessage(MESSAGES.angleOfNiche),
      component: AngleOfNiche,
      error: [validated && validated.angleOfNiche || false] || undefined,
      id: WashBasinDimensionKeys.AngleOfNiche,
    }];
  }
}

export const ConfigurationBasinDimensionsPage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  validated: state.validatedConfiguration,
}))(ConfigurationBasinDimensionsPageComponent);

export default ConfigurationBasinDimensionsPage;